export class RecourseCampaignNegotiationModel {
  public constructor(public readonly negotiationDate?: Date) {}
}
